import { isRouteErrorResponse, Link, useRouteError } from "react-router";

export function ErrorBoundary() {
  const error = useRouteError();
  const isProd = import.meta.env.PROD;

  const getMessage = () => {
    if (isRouteErrorResponse(error)) {
      return error.statusText || error.data?.message || "Something went wrong";
    }

    if (error instanceof Error && !isProd) return error.message;

    return "Something went wrong";
  };

  const message = getMessage();

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-6 p-8">
      <h1 className="text-xl font-semibold text-destructive">Oops!</h1>
      <p className="text-center text-muted-foreground">{message}</p>
      <Link
        to="/"
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Go home
      </Link>
    </div>
  );
}
